<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-h6`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 5a1 1 0 00-1 1v36a1 1 0 001 1h2a1 1 0 001-1V26h17v16a1 1 0 001 1h2a1 1 0 001-1V6a1 1 0 00-1-1h-2a1 1 0 00-1 1v16H6V6a1 1 0 00-1-1H3zm33.219 21.469a7.163 7.163 0 013.402-.861c2.07 0 3.847.798 5.3 2.38 1.451 1.581 2.177 3.623 2.177 6.098 0 1.622-.338 3.134-1.012 4.53-.68 1.41-1.623 2.498-2.822 3.253-1.198.754-2.555 1.131-4.062 1.131-2.562 0-4.672-.99-6.293-2.954-1.618-1.96-2.409-5.121-2.409-9.479 0-4.855.87-8.418 2.642-10.683 1.569-2 3.694-3.006 6.334-3.006 1.974 0 3.615.584 4.898 1.755 1.22 1.114 1.973 2.628 2.26 4.52a.798.798 0 01-.732.905l-2.239.182a.887.887 0 01-.927-.683c-.233-.943-.54-1.622-.9-2.031-.69-.756-1.525-1.128-2.538-1.128-.818 0-1.525.233-2.138.704-.834.633-1.499 1.566-1.992 2.81-.384.971-.63 2.283-.731 3.932a6.81 6.81 0 011.782-1.375zm-1.384 7.634c0 .963.197 1.882.59 2.763.385.86.915 1.506 1.593 1.948.684.446 1.393.666 2.135.666 1.08 0 1.997-.448 2.785-1.367.793-.925 1.195-2.198 1.195-3.843 0-1.574-.394-2.785-1.172-3.66-.775-.87-1.737-1.299-2.92-1.299-1.176 0-2.158.432-2.977 1.309-.819.876-1.229 2.027-1.229 3.483z"/></svg>
</template>
<script>

export default {
  name: 'IconH6',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
